import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'sr',
  Pagination: {
    items_per_page: '/ strani',
    jump_to: 'Idi na',
    page: '',
    prev_page: 'Prethodna strana',
    next_page: 'Sledeća strana',
    prev_5: 'Prethodnih 5 Strana',
    next_5: 'Sledećih 5 Strana',
    prev_3: 'Prethodnih 3 Strane',
    next_3: 'Sledećih 3 Strane',
  },
  DatePicker: {
    lang: {
      placeholder: 'Izaberi datum',
      yearPlaceholder: 'Izaberi godinu',
      quarterPlaceholder: 'Izaberi tromesečje',
      monthPlaceholder: 'Izaberi mesec',
      weekPlaceholder: 'Izaberi sedmicu',
      rangePlaceholder: [
        'Datum početka',
        'Datum završetka',
      ],
      rangeYearPlaceholder: [
        'Godina početka',
        'Godina završetka',
      ],
      rangeMonthPlaceholder: [
        'Mesec početka',
        'Mesec završetka',
      ],
      rangeWeekPlaceholder: [
        'Sedmica početka',
        'Sedmica završetka',
      ],
      locale: 'sr_RS',
      today: 'Danas',
      now: 'Sada',
      backToToday: 'Vrati se na danas',
      ok: 'U redu',
      clear: 'Obriši',
      month: 'Mesec',
      year: 'Godina',
      timeSelect: 'Izaberi vreme',
      dateSelect: 'Izaberi datum',
      monthSelect: 'Izaberi mesec',
      yearSelect: 'Izaberi godinu',
      decadeSelect: 'Izaberi deceniju',
      yearFormat: 'YYYY',
      dateFormat: 'DD.MM.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Prethodni mesec (PageUp)',
      nextMonth: 'Sledeći mesec (PageDown)',
      previousYear: 'Prethodna godina (Control + left)',
      nextYear: 'Sledeća godina (Control + right)',
      previousDecade: 'Prethodna decenija',
      nextDecade: 'Sledeća decenija',
      previousCentury: 'Prethodni vek',
      nextCentury: 'Sledeći vek',
    },
    timePickerLocale: {
      placeholder: 'Izaberi vreme',
      rangePlaceholder: [
        'Vreme početka',
        'Vreme završetka',
      ],
    },
  },
  TimePicker: {
    placeholder: 'Izaberi vreme',
    rangePlaceholder: [
      'Vreme početka',
      'Vreme završetka',
    ],
  },
  Calendar: {
    lang: {
      placeholder: 'Izaberi datum',
      yearPlaceholder: 'Izaberi godinu',
      quarterPlaceholder: 'Izaberi tromesečje',
      monthPlaceholder: 'Izaberi mesec',
      weekPlaceholder: 'Izaberi sedmicu',
      rangePlaceholder: [
        'Datum početka',
        'Datum završetka',
      ],
      rangeYearPlaceholder: [
        'Godina početka',
        'Godina završetka',
      ],
      rangeMonthPlaceholder: [
        'Mesec početka',
        'Mesec završetka',
      ],
      rangeWeekPlaceholder: [
        'Sedmica početka',
        'Sedmica završetka',
      ],
      locale: 'sr_RS',
      today: 'Danas',
      now: 'Sada',
      backToToday: 'Vrati se na danas',
      ok: 'U redu',
      clear: 'Obriši',
      month: 'Mesec',
      year: 'Godina',
      timeSelect: 'Izaberi vreme',
      dateSelect: 'Izaberi datum',
      monthSelect: 'Izaberi mesec',
      yearSelect: 'Izaberi godinu',
      decadeSelect: 'Izaberi deceniju',
      yearFormat: 'YYYY',
      dateFormat: 'DD.MM.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Prethodni mesec (PageUp)',
      nextMonth: 'Sledeći mesec (PageDown)',
      previousYear: 'Prethodna godina (Control + left)',
      nextYear: 'Sledeća godina (Control + right)',
      previousDecade: 'Prethodna decenija',
      nextDecade: 'Sledeća decenija',
      previousCentury: 'Prethodni vek',
      nextCentury: 'Sledeći vek',
    },
    timePickerLocale: {
      placeholder: 'Izaberi vreme',
      rangePlaceholder: [
        'Vreme početka',
        'Vreme završetka',
      ],
    },
  },
  global: {
    placeholder: 'Izaberi',
  },
  Table: {
    filterTitle: 'Meni filtera',
    filterConfirm: 'U redu',
    filterReset: 'Poništi',
    filterEmptyText: 'Nema filtera',
    emptyText: 'Nema podataka',
    selectAll: 'Izaberi trenutnu stranicu',
    selectInvert: 'Obrni izbor trenutne stranice',
    selectNone: 'Obriši sve podatke',
    selectionAll: 'Izaberi sve podatke',
    sortTitle: 'Sortiraj',
    expand: 'Proširi red',
    collapse: 'Skupi red',
    triggerDesc: 'Klikni da sortiraš po padajućem redosledu',
    triggerAsc: 'Klikni da sortiraš po rastućem redosledu',
    cancelSort: 'Klikni da otkažeš sortiranje',
  },
  Modal: {
    okText: 'U redu',
    cancelText: 'Otkaži',
    justOkText: 'U redu',
  },
  Popconfirm: {
    okText: 'U redu',
    cancelText: 'Otkaži',
  },
  Transfer: {
    titles: [
      '',
      '',
    ],
    searchPlaceholder: 'Pretraži ovde',
    itemUnit: 'stavka',
    itemsUnit: 'stavki',
    remove: 'Ukloni',
    selectCurrent: 'Izaberi trenutnu stranicu',
    removeCurrent: 'Ukloni trenutnu stranicu',
    selectAll: 'Izaberi sve podatke',
    removeAll: 'Ukloni sve podatke',
    selectInvert: 'Obrni izbor trenutne stranice',
  },
  Upload: {
    uploading: 'Otpremanje...',
    removeFile: 'Ukloni datoteku',
    uploadError: 'Greška pri otpremanju',
    previewFile: 'Pregledaj datoteku',
    downloadFile: 'Preuzmi datoteku',
  },
  Empty: {
    description: 'Nema podataka',
  },
  Icon: {
    icon: 'ikona',
  },
  Text: {
    edit: 'Uredi',
    copy: 'Kopiraj',
    copied: 'Kopirano',
    expand: 'Proširi',
  },
  PageHeader: {
    back: 'Nazad',
  },
  Form: {
    optional: '(opcionalno)',
    defaultValidateMessages: {
      default: 'Greška pri proveri valjanosti za ${label}',
      required: 'Unesi ${label}',
      enum: '${label} mora da bude nešto od [${enum}]',
      whitespace: '${label} ne može biti prazan znak',
      date: {
        format: '${label} format datuma je nevažeći',
        parse: '${label} se ne može konvertovati u datum',
        invalid: '${label} je nevažeći datum',
      },
      types: {
        string: '${label} nije važeći ${type}',
        method: '${label} nije važeći ${type}',
        array: '${label} nije važeći ${type}',
        object: '${label} nije važeći ${type}',
        number: '${label} nije važeći ${type}',
        date: '${label} nije važeći ${type}',
        boolean: '${label} nije važeći ${type}',
        integer: '${label} nije važeći ${type}',
        float: '${label} nije važeći ${type}',
        regexp: '${label} nije važeći ${type}',
        email: '${label} nije važeći ${type}',
        url: '${label} nije važeći ${type}',
        hex: '${label} nije važeći ${type}',
      },
      string: {
        len: '${label} mora da sadrži ${len} znakova',
        min: '${label} mora da sadrži bar ${min} znakova',
        max: '${label} mora da sadrži do ${max} znakova',
        range: '${label} mora da sadrži između ${min} i ${max} znakova',
      },
      number: {
        len: '${label} mora biti jednak ${len}',
        min: '${label} mora biti najmanje ${min}',
        max: '${label} mora biti najviše ${max}',
        range: '${label} mora biti između ${min} i ${max}',
      },
      array: {
        len: 'Mora biti ${len} ${label}',
        min: 'Najmanje ${min} ${label}',
        max: 'najviše ${max} ${label}',
        range: 'Iznos ${label} mora biti između ${min} i ${max}',
      },
      pattern: {
        mismatch: '${label} ne odgovara obrascu ${pattern}',
      },
    },
  },
  Image: {
    preview: 'Pregled',
  },
};

export default localeValues;
